const AdminSettings = () => {
  return (
    <div>
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900">System Settings</h1>
        <p className="text-gray-600">Configure system-wide settings and preferences.</p>
      </div>

      <div className="bg-white shadow rounded-lg p-6">
        <p className="text-gray-500">System settings interface coming soon...</p>
      </div>
    </div>
  )
}

export default AdminSettings